import { CountriesWithCustomizedWTB, CountriesWithCustomizedWTBImage } from "../constants";
import { ITWorkshop } from "../interface";
import publicImage from "./publicImage";
import _ from 'lodash';

// eslint-disable-next-line
export const generateQueryString = (obj: any) => {
  const strPart = [];
  for (const p in obj) {
    if (
      Object.prototype.hasOwnProperty.call(obj, p) &&
      ((typeof obj[p] === 'number' && obj[p] !== null) || !!obj[p])
    ) {
      strPart.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
    }
  }
  return strPart.join('&');
};

export const getLocationImage = (location: ITWorkshop): string => {
  if (location.images) {
    return location.images[0];
  }

  if (CountriesWithCustomizedWTB.includes(localStorage.countryCode)) {
    return publicImage("workshop-07.jpg");
  } else if (CountriesWithCustomizedWTBImage.includes(localStorage.countryCode)) {
    return publicImage("workshop-09.jpg");
  }

  return publicImage("workshop-01.jpg");
}

export const isNZL = (v?: string) => {
  return _.isEqual(v, 'NZL')
}

export const isAU = (v?: string) => {
  return _.isEqual(v, 'AUS')
}

export const isUS = (v?: string) => {
  return _.isEqual(v, 'USA')
}
